import { AsyncPageRender } from '@components/AsyncComponent';
import { ProtectedRoute } from '@components/Layout/ProtectedRoute';
import { pageModule } from '@components/pageModule';
import React from 'react';
import { Route } from 'react-router';

export const routes$ = {
    Reports: AsyncPageRender(() => pageModule(import('./Reports'))),
};

function Router() {
    return (
        <>
            <Route exact path={'/operations/reports'} component={ProtectedRoute(routes$.Reports)} />
        </>
    );
}

export default Router;
